module.exports = __webpack_public_path__ + "static/media/klipkutter.6e64667f.png";